import React from "react";

const Button = ({ children }) => {
  return <button className="btn w-48 my-3">{children}</button>;
};

export default Button;
